// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gbn0D","buttons":"styles_buttons__2fG5l"};